<script lang="ts">
  import cn from 'classnames';
  import { twMerge } from 'tailwind-merge';
  import { createEventDispatcher } from 'svelte';
  import type { FieldState } from '@shared/lib';
  import { Field } from '@shared/ui/fields/field';
  import type { HTMLInputAttributes } from 'svelte/elements';

  const dispatcher = createEventDispatcher<{ change: string; input: string }>();
  export let placeholder = '';
  export let type: 'text' | 'email' | 'number' | 'tel' = 'text';
  export let required = false;
  export let label: string | undefined = undefined;
  export let helperText: string | undefined = undefined;
  export let state: FieldState = 'default';
  export let containerClass = '';
  export let value = '';
  export let name: string;
  export let inputmode: HTMLInputAttributes['inputmode'] = 'text';

  export let noMargin = false;
  export let fieldClass = '';

  export let min: number | undefined = undefined;
  export let max: number | undefined = undefined;

  function inputHandler(e: Event & { currentTarget: EventTarget & HTMLInputElement }) {
    state === 'error' && (state = 'default') && (helperText = '');
    value = e.currentTarget.value.trim();

    dispatcher('input', value);
  }

  const onChangeHandler = (e: Event & { currentTarget: EventTarget & HTMLInputElement }) => {
    dispatcher('change', e.currentTarget.value.trim());
  };
</script>

<Field {state} {helperText} {label} {noMargin} {containerClass}>
  <input
    class="{twMerge(
      cn(
        'input placeholder-default-500 dark:placeholder-dark-500 w-full rounded-lg bg-transparent px-4 py-3 outline-none',
        {
          '[&::-webkit-inner-spin-button]:appearance-none': type === 'number',
        },
      ),
      fieldClass,
    )}"
    {type}
    on:focus="{() => state === 'error' || state === 'success' || (state = 'active')}"
    on:blur="{() => state === 'error' || state === 'success' || (state = 'default')}"
    on:input="{inputHandler}"
    on:change="{onChangeHandler}"
    {required}
    placeholder="{placeholder + (required ? '*' : '')}"
    disabled="{state === 'disabled'}"
    {value}
    {min}
    {max}
    {name}
    {inputmode}
  />
  <slot />
</Field>
